export default [
  {
    name: 'Clean Building Expo',
    booth: '312',
    days: 'March 26 - 27, 2019',
    description:
      'Solutions for Today, Inspiration for Tomorrow. A Gathering of the Best Minds in the Cleaning Industry.',
    location: 'Baltimore, MD',
    url: 'https://cleanbuildingsexpo.com/'
  },
  {
    name: 'IFMA Facility Fusion',
    booth: '605',
    days: 'April 8 - 10, 2019',
    description:
      'Geared toward the unique needs and challenges in managing specific types of facilities, projects and teams.',
    location: 'Atlanta, GA',
    url: 'https://facilityfusion.ifma.org/'
  },
  {
    name: 'BSCAI Executive Management',
    booth: 'TT2',
    days: 'May 16 - 18, 2019',
    description:
      'Bringing together BSC management teams to discuss strategies to achieve priorities and to learn from industry leaders.',
    location: 'Broomfield, CO',
    url: 'https://www.bscai.org/exec'
  },
  {
    name: 'ISSA Show North America',
    booth: '605',
    days: 'November 18 - 21, 2019',
    description:
      'The top event for professionals in the cleaning industry and the one show for cleaning and maintenance solutions.',
    location: 'Las Vegas, NV',
    url: 'https://show.issa.com/'
  },
  {
    name: 'BSCAI Contracting Success',
    booth: '605',
    days: 'November 20 - 22, 2019',
    description:
      'Dedicated to providing better business solutions tailored exclusively to the Building Service Contractor.',
    location: 'Las Vegas, NV',
    url: 'https://convention.bscai.org/'
  }
]
